export const LABEL_LA = {

}
